__turbopack_context__.v({
  "className": "ibm_plex_mono_7dd7a6d3-module___ytagq__className",
});
